<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible="visible"
      :title="showDetailTitle"
      width="370px"
      class="make-invoice-adjust-balance-dialog"
      :close-on-click-modal="false"
      :show-close="true"
      @close="cancel"
    >
      <div>
        <cargo-ag-grid
          :locale-text-func="_i18nGridLocalText"
          :grid-options="gridOptionsFileDetail"
          :column-defs="columnDefsFileDetail"
          :row-data="rowDataFileDetail"
          :enable-col-resize="true"
          :enable-sorting="true"
          class="ag-theme-balham"
          style="width:350px;height: 300px"
          @gridReady="params=>gridApiFileDetail=params.api"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'FileDetailFormWindow',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    showDetailTitle: { type: String, required: true },
    rowDataFileDetail: { type: Array, required: false }
  },
  data() {
    return {
      loading: false,
      gridApiFileDetail: null,
      gridOptionsFileDetail: {
        context: {
          componentParent: this
        }
      },
      columnDefsFileDetail: [
        {
          headerName: this.$t('FileHistory.tagName'),
          field: 'key',
          width: 150
        },
        {
          headerName: this.$t('FileHistory.tagValue'),
          field: 'val',
          width: 200
        }
      ]
    }
  },
  computed: {
  },
  async beforeMount() {

  },
  mounted() {

  },
  methods: {
    cancel() {
      this.$emit('onClose')
    }
  }
}
</script>
<style scoped>

ul li {
  list-style: none;
  font-size: 13px;
  color: #909399;
}
</style>

